{
  "title": "Guarantees",
  "hint": "Guarantees the company gave the client and received from suppliers and subcontractors. Projects keeps the register and reminds you {{days}} days before each expiry; margin cash and bank fees move in Finance and Expenses.",
  "add": "Add guarantee",
  "given": "Given",
  "received": "Received",
  "openNamed": "Open {{type}} {{reference}}",
  "loading": "Loading the guarantee…",
  "edit": "Edit",
  "empty": {
    "title": "No guarantees yet",
    "body": "Add the performance bond and the advance payment guarantee when the bank issues them.",
    "readOnly": "The project’s guarantees appear here."
  },
  "mark": {
    "today": "Expires today",
    "expiresIn_one": "Expires in {{n}} day",
    "expiresIn_other": "Expires in {{n}} days"
  },
  "status": {
    "ACTIVE": "Active",
    "RELEASED": "Released",
    "CALLED": "Called",
    "EXPIRED": "Expired"
  },
  "type": {
    "BID": "Bid bond",
    "PERFORMANCE": "Performance bond",
    "ADVANCE_PAYMENT": "Advance payment guarantee",
    "RETENTION": "Retention bond",
    "MAINTENANCE": "Maintenance bond"
  },
  "direction": {
    "GIVEN": "Given",
    "RECEIVED": "Received"
  },
  "directionHint": {
    "GIVEN": "Given to the client by our bank",
    "RECEIVED": "Received from a supplier or subcontractor"
  },
  "col": {
    "reference": "Guarantee no.",
    "project": "Project",
    "type": "Type",
    "bank": "Bank",
    "counterparty": "Counterparty",
    "amount": "Amount",
    "percent": "% of contract",
    "expiry": "Expiry",
    "status": "Status",
    "bankCounterparty": "Bank · counterparty",
    "expiryStatus": "Expiry and status"
  },
  "form": {
    "newTitle": "New guarantee",
    "editTitle": "Edit guarantee {{reference}}",
    "body": "As the bank’s letter reads it. Extensions, reductions and releases are recorded as events afterwards, with the bank’s letter as evidence.",
    "type": "Type",
    "reference": "Guarantee number",
    "referenceHint": "The bank’s reference on the letter.",
    "bank": "Bank",
    "beneficiary": "Beneficiary",
    "issuer": "Given by",
    "amount": "Amount",
    "bondHint": "{{pct}} of the contract’s current value is {{amount}}.",
    "useProposed": "Use it",
    "margin": "Cash margin",
    "marginHint": "What the bank holds against it (for information; Finance moves the money).",
    "issueDate": "Issued on",
    "expiryDate": "Expires on",
    "claimEnd": "Last day for a claim",
    "claimEndHint": "Only when it differs from the expiry.",
    "notes": "Notes",
    "save": "Save guarantee",
    "create": "Add guarantee",
    "error": {
      "amount": "Enter an amount above zero.",
      "expiryOrder": "The expiry is before the issue date.",
      "margin": "The margin cannot be negative.",
      "required": "Required"
    }
  },
  "toast": {
    "saved": "Guarantee saved",
    "added": "Guarantee {{reference}} added"
  },
  "reducible": {
    "title": "Reducible",
    "body": "The advance still outstanding is {{amount}}: the client may agree to reduce this guarantee to it.",
    "hint": "The advance still outstanding is {{amount}}."
  },
  "events": {
    "actions": "Record what the bank did",
    "title": "History",
    "none": "No changes since it was issued.",
    "called": "Called {{amount}}",
    "newAmount": "Amount now {{amount}}",
    "newExpiry": "Expires on {{date}}"
  },
  "event": {
    "EXTEND": "Extend",
    "REDUCE": "Reduce",
    "AMEND": "Amend",
    "RELEASE": "Release",
    "CALL": "Call"
  },
  "eventDone": {
    "EXTEND": "Extended",
    "REDUCE": "Reduced",
    "AMEND": "Amended",
    "RELEASE": "Released",
    "CALL": "Called"
  },
  "eventTitle": {
    "EXTEND": "Extend {{reference}}",
    "REDUCE": "Reduce {{reference}}",
    "AMEND": "Amend {{reference}}",
    "RELEASE": "Release {{reference}}",
    "CALL": "Record a call on {{reference}}"
  },
  "eventHint": {
    "EXTEND": "The bank extended the expiry. Attach its letter to the guarantee.",
    "REDUCE": "The bank reduced the amount, usually as the advance is recovered or the work is accepted.",
    "AMEND": "The bank changed the amount, the expiry or both.",
    "RELEASE": "The guarantee went back to the bank. It stops counting as a contingent liability.",
    "CALL": "The beneficiary claimed on the guarantee. Record the bank’s debit in Finance."
  },
  "eventBody": {
    "EXTEND": "The expiry moves from {{from}} to {{to}}; the reminders start again from the new date.",
    "REDUCE": "The amount goes from {{from}} to {{to}}.",
    "AMEND": "The guarantee keeps its status; what you enter replaces the amount or the expiry.",
    "RELEASE": "{{reference}} becomes RELEASED: no more reminders, and it leaves the contingent liabilities from this date.",
    "CALL": "The guarantee becomes CALLED for {{amount}}. Nothing is posted here: the bank’s debit is recorded in Finance."
  },
  "eventForm": {
    "date": "Date",
    "newExpiry": "New expiry",
    "newAmount": "New amount",
    "calledAmount": "Amount called",
    "current": "Now {{amount}}.",
    "note": "Note",
    "noteHint": "What happened and the bank’s reference. Every change needs one.",
    "noteRequired": "Say what happened.",
    "laterExpiry": "Choose a date after the current expiry.",
    "lowerAmount": "Enter an amount below the current one.",
    "calledInvalid": "Enter an amount above zero and at most the guarantee’s amount.",
    "amendSomething": "Enter a new amount, a new expiry or both."
  },
  "eventToast": {
    "EXTEND": "{{reference}} extended",
    "REDUCE": "{{reference}} reduced",
    "AMEND": "{{reference}} amended",
    "RELEASE": "{{reference}} released",
    "CALL": "Call on {{reference}} recorded"
  },
  "register": {
    "title": "Guarantees",
    "meta": "Guarantees of every project, given and received",
    "views": "Guarantee views",
    "tab": "Register",
    "csv": "Export CSV",
    "csvFailed": "The export failed. Try again.",
    "empty": "No guarantees match",
    "emptyBody": "Change the search or the filters, or add guarantees on a project’s Contract tab › Guarantees.",
    "count_one": "{{n}} guarantee · in force: given {{given}}, received {{received}}",
    "count_other": "{{n}} guarantees · in force: given {{given}}, received {{received}}",
    "clear": "Clear filters",
    "emptyNone": "No guarantees yet",
    "emptyNoneBody": "Guarantees are added on a project's Contract tab › Guarantees."
  },
  "filter": {
    "any": "Any",
    "direction": "Direction",
    "type": "Type",
    "status": "Status",
    "expiring": "Expiring within",
    "days_one": "{{n}} day",
    "days_other": "{{n}} days",
    "project": "Project",
    "search": "Search",
    "searchPlaceholder": "Guarantee no., bank or counterparty",
    "clearSearch": "Clear search"
  },
  "contingent": {
    "tab": "Contingent liabilities",
    "asOf": "As at",
    "hint": "Guarantees in force on {{date}}, with their amounts as they stood that day (extensions, reductions, releases and calls replayed).",
    "given": "Given",
    "givenHint": "What the banks would pay our clients if they called: a contingent liability.",
    "received": "Received",
    "receivedHint": "What we could call from suppliers’ and subcontractors’ banks.",
    "inForce": "In force on that date",
    "none": "None in force.",
    "count": "Count",
    "total": "Total"
  },
  "openProject": "Open project {{code}}",
  "percentOf": "{{pct}} of the contract"
}
